export enum CaseStatusEnum {
  ALL = "",
  UNASSIGNED = "unassigned",
  ASSIGNED = "assigned",
  REPORT_PENDING = "report_pending",
  REPORTED = "reported",
  VIEW = "view",
  TO_BE_APPROVED = "to_be_approved",
}
